import { render, staticRenderFns } from "./ModelPrices.vue?vue&type=template&id=4af53518&scoped=true"
import script from "./ModelPrices.vue?vue&type=script&lang=js"
export * from "./ModelPrices.vue?vue&type=script&lang=js"
import style0 from "./ModelPrices.vue?vue&type=style&index=0&id=4af53518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af53518",
  null
  
)

export default component.exports